import React from 'react';
import LayoutGrid, { confGlyph } from './LayoutGrid';
import Sheet from '../common/Sheet';
import { matchTabletSheet, onTabletSheetChange } from '../util/tabletSheet';

/**
 * LayoutMenu — the desktop bottom-bar Layout control (#86bb5dx62). Moved off the left rail into
 * the bottom bar with the other viewing controls (Scan / Fullscreen / overlays gear + the camera
 * banks), so the bottom bar owns "how you're viewing" and the header breadcrumb owns "what you're
 * viewing" (David). The button shows the current layout (grid icon + conf count); clicking opens
 * an upward popover with the full LayoutGrid; picking a layout or clicking outside closes it.
 * Desktop-only (rendered in the desktop bottom bar) via CSS.
 *
 * Props:
 *   conf           — active conf key ('conf-8', …); the button shows its number
 *   onSelect(conf) — pick a layout (wired to LiveView.selectGridLayout)
 */
class LayoutMenu extends React.Component {
    state = { open: false, tabletSheet: matchTabletSheet() };

    componentDidMount() {
        document.addEventListener('mousedown', this.onDocMouseDown);
        this._offTablet = onTabletSheetChange((m) => this.setState({ tabletSheet: m }));
    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.onDocMouseDown);
        if (this._offTablet) this._offTablet();
    }
    onDocMouseDown = (e) => {
        if (this.state.open && this._wrap && !this._wrap.contains(e.target)) this.setState({ open: false });
    };
    toggleOpen = () => this.setState((s) => ({ open: !s.open }));
    pick = (conf) => { this.setState({ open: false }); if (this.props.onSelect) this.props.onSelect(conf); };

    render() {
        const { open, tabletSheet } = this.state;
        const { conf } = this.props;
        const num = (conf || 'conf-4').replace('conf-', '');
        return (
            <div className={'live-laymenu' + (open ? ' live-laymenu--show' : '')} ref={(el) => { this._wrap = el; }}>
                <button className="live-laymenu__btn" onClick={this.toggleOpen} title="Layout" aria-haspopup="menu" aria-expanded={open}>
                    {/* Accurate active-conf glyph (shared confGlyph) — was a static 2×2 grid icon that made
                        every layout read as conf-4 on the desktop bottom bar (David #86bb7phhh). */}
                    {confGlyph(conf || 'conf-4')}
                    <span className="live-laymenu__num">{num}</span>
                </button>
                {/* Tablet (< 1280): the mobile bottom SHEET; desktop (>= 1280): the anchored popover. */}
                {tabletSheet ? (
                    open && (
                        <Sheet className="app-sheet live-bar-sheet" title="Layout" ariaLabel="Layout" onClose={() => this.setState({ open: false })}>
                            <LayoutGrid conf={conf} onSelect={this.pick} />
                        </Sheet>
                    )
                ) : (
                    <div className="live-laymenu__pop" role="menu">
                        <div className="live-laymenu__hd">Layout</div>
                        <LayoutGrid conf={conf} onSelect={this.pick} />
                    </div>
                )}
            </div>
        );
    }
}

export default LayoutMenu;
